<template>
  <div class="sponsors-wrapper">
    <div class="panel" v-for="(section, index) in sections" :key="index">
      <div class="panel__title">{{ section.title }}</div>
      <div class="panel__content sponsors">
        <div
          class="sponsor"
          v-for="(sponsor, index2) in section.sponsors"
          :key="index2"
        >
          <component
            :is="sponsor.url ? 'a' : 'div'"
            class="sponsor__link"
            :class="{'sponsor__link-largefont': sponsor.largefont }"
            target="_blank"
            :href="sponsor.url"
          >
            <img v-if="sponsor.logo" :src="sponsor.logo" :alt="sponsor.name" />
            <div v-else v-html="sponsor.name">
            </div>
          </component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
  },
  data() {
    const getImage = (name) => require(`@/assets/sponsors/${name}.png`);

    return {
      sections: [
        {
          title: "Presented by",
          sponsors: [
            { name: "Delta", url: "https://www.delta.com/", logo: getImage("delta") },
            { name: "Novelis", url: "https://novelis.com/", logo: getImage("novelis") },
          ],
        },
        {
          title: "Diamond",
          sponsors: [
            { name: "Bluelagoon", url: "https://www.bluelagoonfoundation.org/", logo: getImage("bluelagoon") },
            { name: "Donna Kennedy", url: "", largefont: true },
          ],
        },
        {
          title: "Platinum",
          sponsors: [
            { name: "Brown & Co", url: "https://www.brownjewelers.com/", logo: getImage("brownco") },
            { name: "CocaCola", url: "https://us.coca-cola.com/", logo: getImage("cocacola") },
            { name: "Lauren & Michael Gearon" },
            { name: "Inspire", url: "https://inspirebrands.com/", logo: getImage("inspire") },
            {
              name: "Mercedes-Benz of Buckhead",
              url: "https://www.mercedesofbuckhead.com/",
              logo: getImage("mercedes"),
            },
            { name: "PWC", url: "https://www.pwc.com/", logo: getImage("pwc") },
            { name: "Emily & Louis\nShapiro", url: "" },
            { name: "Todd Banister Team", url: "https://toddbanisterweb.harrynorman.com/", logo: getImage("todd") },
            { name: "Ellen & John\nYates", url: "" },
          ],
        },
        {
          title: "Gold",
          sponsors: [
            { name: "Donna & Matt<br/>Baker", url: "", logo: "" },
            {
              name: "Culture Index",
              url: "https://www.cindexinc.com/",
              logo: getImage("culture_index"),
            },
            { name: "Dynami", url: "http://www.dynamigroup.com/", logo: getImage("dynami") },
            { name: "Jessica & Chris\nEachus", url: "", logo: "" },
            { name: "The Glavine<br/>Family", url: "", logo: "" },
            {
              name: "Helen Marie Stern Fund",
              url: "",
              logo: getImage("helen_marie"),
            },
            { name: "Peggy & Rodger\nHerndon and Deloitte", url: "", logo: "" },
            { name: "Homrich Berg", url: "https://homrichberg.com/", logo: getImage("homrich_berg") },
            { name: "Julie & Mel\nLandis", url: "" },
            {
              name: "Rec Tec Grills",
              url: "https://www.rectecgrills.com/",
              logo: getImage("rec_tec_grills"),
            },
            { name: "Lisa & Robert\nReeves", url: "", logo: "" },
            { name: "11Alive", url: "https://www.11alive.com/", logo: getImage("alive") },
            { name: "Eileen\nVilloutreix", url: "", logo: "" },
          ],
        },
        {
          title: "Silver",
          sponsors: [
            {
              name: "AFIAC Cancer & blood disorders center",
              url: "https://www.choa.org/medical-services/cancer-and-blood-disorders/aflac-cancer-and-blood-disorder-center",
              logo: getImage("afiac"),
            },
            { name: "Alston & Bird", url: "https://www.alston.com/en/offices/atlanta", logo: getImage("alston_bird") },
            { name: "Buckel Design Group", url: "https://www.bdgse.com/", logo: getImage("bdg") },
            { name: "Gephardt Group", url: "https://www.gephardtgroup.com/", logo: getImage("gephardt") },
            { name: "Greenberg Traurig", url: "https://www.gtlaw.com/en/locations/atlanta", logo: getImage("greenberg") },
            { name: "KPN Consulting", url: "https://www.kpnconsulting.net/", logo: getImage("kpn") },
            { name: "Heidi & Andy<br/>Nelson", url: "", logo: "" },
            {
              name: "Richard Bower & Co",
              url: "http://www.richardbowers.com/",
              logo: getImage("richard_bower_co"),
            },
            { name: "Stephanie & Andy<br/>Shearer", url: "", logo: "" },
            { name: "Sheba & Mark<br/>Veeder", url: "", logo: "" },
            { name: "Cheri & Roger<br/>Weitkamp", url: "", logo: "" },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.sponsors {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 30px;
}

.sponsors-wrapper {
  margin: 0 30px 50px 100px;
  padding: 10px;
}

.sponsor {
  margin: 25px;
  max-width: 235px;

  &__link {
    text-transform: capitalize;
    color: #676767;
    line-height: 1.2;
    text-decoration: none;
    display: flex;
    align-items: center;
    text-align: center;
    padding: 6px;
    white-space: pre-line;

    img {
      max-height: 90px;
      max-width: 235px;
    }
  }
}

.sponsor__link {
  font-size: 18px;
  &.sponsor__link-largefont{
    font-size: 36px
  }
}

@media screen and (max-width: 1264px) {
  .sponsors-wrapper {
    margin: 40px;
  }
}

@media screen and (max-width: 800px) {
  .sponsors-wrapper {
    margin: 20px;
  }

  .sponsor {
    margin: 6px;
    max-width: 45%;
  }

  .sponsor__link {
    font-size: 14px;
    &.sponsor__link-largefont{
      font-size: 18px
    }
    img {
      max-width: 100%;
    }
  }

}
</style>
